

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Currency } from '../models/currency';
import { Department } from '../models/department';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  apiEndpoint: string="";
  baseApiUrl: any;
  apiUniqueId: string = 'currency/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E';

  constructor(private httpService: HttpWrapperService, 
    private http: HttpClient,
    private configService: ConfigService) { 
      this.apiEndpoint = this.configService.getConfigValue("apiEndpoint");
      this.apiEndpoint += this.apiUniqueId;
    }
    getAllCurrency(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Currency>>{ 
      return this.httpService.get(this.apiEndpoint + '/getAllCurrency?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                   
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }

    viewCurrency(Currency_Id?: string): Observable<Array<Currency>> {
      return this.httpService.get(this.apiEndpoint + '/viewCurrency/' + (Currency_Id ? Currency_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    saveCurrency(currency: Currency): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/saveCurrency/', currency).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    deleteCurrency(Currency_Id?: string): Observable<any> {
      return this.httpService.post(this.apiEndpoint + '/deleteCurrency/' + (Currency_Id ? Currency_Id : '00000000-0000-0000-0000-000000000000'), Currency_Id).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    checkDuplication(Currency_Id?: string, CurrencyCode?: string ): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkDuplication?Currency_Id=' + (Currency_Id ? Currency_Id : '00000000-0000-0000-0000-000000000000')+ '&CurrencyCode=' + (CurrencyCode ? CurrencyCode : '')).pipe(map((result: any) => {
          return result; 
      }));
    }


  
  }

